module.exports = __webpack_public_path__ + "static/media/battery-full.60a4473a.svg";